import React, { useEffect, useState } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { GreenCheckbox } from '../../../../../components/FlowConfigurationInputs';
import { useTranslation } from 'react-i18next';
import UpdateRole from '../../../roleEditor/UpdateRole';

function Roles({ roles, setRoles, rolesChecked, setRolesChecked, userType, setRoleState }) {
    const { t } = useTranslation();
    const [list, setList] = useState([...roles.current, ...rolesChecked.current]);
    const [showDialog, setShowDialog] = useState();
    const getValue = () => {
        let value = {}
        for (const item of roles.current) {
            value[item.id] = false;
        }
        for (const item of rolesChecked.current) {
            value[item.id] = true;
        }
        return value;
    }
    const [state, setState] = useState({});
    useEffect(() => {
        setState(getValue());
        setList([...roles.current, ...rolesChecked.current]);
    }, [roles.current, rolesChecked.current]);

    const handleChange = (e, item) => {
        let checked = e.target.checked;
        let value = e.target.value;
        if (checked) { rolesChecked.current.push(roles.current.splice(roles.current.indexOf(item), 1)[0]); }
        else { roles.current.push(rolesChecked.current.splice(rolesChecked.current.indexOf(item), 1)[0]); }
        setState({ ...state, [value]: checked });
    }
    return (
        <>
            <div className="user-role">
                {list.map((item, itemI) => {
                    return (
                        <FormControlLabel
                            key={itemI}
                            control={
                                <GreenCheckbox
                                    size="small"
                                    checked={!!state[item.id]}
                                    onChange={(e) => { handleChange(e, item); }}
                                    value={item.id}
                                />
                            }
                            label={<span className="user-role-label">{item.role_name}</span>}
                        />
                    )
                })}
                {userType &&
                    <FormControlLabel
                        control={<GreenCheckbox size="small" checked={true} />}
                        label={<span className="user-role-label">{userType}</span>}
                        disabled
                    />
                }
            </div>
            {/* <button className="add-role-button" onClick={() => { setShowDialog({ type: 'add' }); }}>+ {t('CONTENT.ROLE.ADD-NEW-ROLE')}</button> */}
            {showDialog && <UpdateRole dialog={showDialog} setDialog={setShowDialog} roles={roles.current} fetchData={() => { setRoleState(a => !a) }} />}
        </>
    )
}
export default Roles;